import React, { useState, useEffect } from "react";
import axios from "axios";
import MapsManagerBooking from "./MapsManagerBooking";
import "react-phone-number-input/style.css";
import PhoneInput from "react-phone-number-input";
import NumberSetupCss from "./NumberSetup.module.css";

const NumberSetup = ({ eventId, activeSubTab, id, clubs }) => {
  console.log(
    " eventId, activeSubTab, id, clubs",
    "YOOO HERE WE ARE CODING ",
    eventId,
    activeSubTab,
    id,
    clubs
  );
  //console.log("NUMBER SETUP WE SEE FIRST THE clubs", clubs);
  const [phoneNumber, setPhoneNumber] = useState(null);
  const [userInputPhone, setUserInputPhone] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const adminKey = "Bearer " + process.env.REACT_APP_ADMIN_KEY;
  const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

  useEffect(() => {
    // Check if phone number is available in localStorage
    const storedPhoneNumber = localStorage.getItem("phoneNumber");
    if (storedPhoneNumber) {
      setPhoneNumber(storedPhoneNumber);
    }
    setIsLoading(false);
  }, []);

  const handlePhoneSubmit = async () => {
    if (userInputPhone) {
      try {
        let token = localStorage.getItem("token");
        // Post phone number to backend
        await axios.post(
          `${BACKEND_URL}/admin/phone-setup/`,
          {
            phoneNumber: userInputPhone,
            id: id
          },
          {
            headers: {
              authorization: `Bearer ${token}`
            }
          }
        );

        // Store phone number in localStorage
        localStorage.setItem("phoneNumber", userInputPhone);

        // Set phone number in state
        setPhoneNumber(userInputPhone);
        setError(null); // Clear errors if any
      } catch (err) {
        console.error(err);
        setError("Unable to save phone number, please try again.");
      }
    }
  };

  if (isLoading) {
    return <div>Loading...</div>;
  }

  if (phoneNumber && phoneNumber !== "undefined" && phoneNumber !== "") {
    //console.log("phoneNumber : ", phoneNumber);
    // Phone number is set, allow access to MapsManagerBooking
    return activeSubTab === "tablebooking" ? (
      <MapsManagerBooking eventId={eventId} clubs={clubs} />
    ) : (
      <p>Nothing to see</p>
    );
  }

  // Phone number is not set, ask the user to input their phone number
  return (
    <div>
      <h3>Please set up your phone number to access the booking feature.</h3>
      <div className={NumberSetupCss.editForm}>
        <div className={NumberSetupCss.formGroup}>
          <PhoneInput
            international
            defaultCountry="US"
            placeholder="Enter phone number"
            value={userInputPhone}
            onChange={setUserInputPhone}
            className={NumberSetupCss.phoneInput}
          />
        </div>
        <button
          className={NumberSetupCss.submitButton}
          onClick={handlePhoneSubmit}
        >
          Submit
        </button>
        {error && <p style={{ color: "red" }}>{error}</p>}
      </div>
    </div>
  );
};

export default NumberSetup;
